// Datos de respaldo — mismo shape que la API real de Ego
// (se usan solo si REACT_APP_API_URL no está seteada o la API no responde)
const PLACEHOLDER_THUMB = "https://placehold.co/400x260/eb0a1e/ffffff?text=";
const PLACEHOLDER_PHOTO = "https://placehold.co/900x500/191919/ffffff?text=";
const PLACEHOLDER_FEATURE = "https://placehold.co/500x320/f0f0f0/333333?text=";
const PLACEHOLDER_HIGHLIGHT = "https://placehold.co/700x450/eeeeee/333333?text=";

const baseCars = [
  { id: 1, name: "Corolla",        segment: "Sedan",                 year: 2021, price: 3817000 },
  { id: 2, name: "Camry",          segment: "Sedan",                 year: 2020, price: 4250400 },
  { id: 3, name: "Yaris Hatchback",segment: "Hatchback",             year: 2021, price: 2585000 },
  { id: 4, name: "Etios",          segment: "Hatchback",             year: 2021, price: 1731000 },
  { id: 5, name: "Hilux",          segment: "Pickups y Comerciales", year: 2021, price: 3410000 },
  { id: 6, name: "Hiace Furgón",   segment: "Pickups y Comerciales", year: 2021, price: 3645200 },
  { id: 7, name: "Rav4",           segment: "SUVs",                  year: 2021, price: 2960500 },
  { id: 8, name: "SW4",            segment: "SUVs",                  year: 2022, price: 6892000 },
];

function buildDetail(car) {
  const encodedName = encodeURIComponent(car.name);
  return {
    ...car,
    thumbnail: `${PLACEHOLDER_THUMB}${encodedName}`,
    photo: `${PLACEHOLDER_PHOTO}${encodedName}`,
    title: `Conocé el nuevo ${car.name}`,
    description: `El <b>${car.name} ${car.year}</b> combina diseño, tecnología y eficiencia. Un modelo pensado para acompañar tu día a día con el respaldo y la confiabilidad de siempre.`,
    model_highlights: [
      {
        title: "Tecnología de punta",
        content: `El ${car.name} incorpora el último sistema multimedia con pantalla táctil, conectividad Apple CarPlay y Android Auto, y una suite completa de asistentes a la conducción.`,
        image: `${PLACEHOLDER_HIGHLIGHT}Tecnologia`,
      },
      {
        title: "Diseño y confort",
        content: `Un interior pensado para el confort de todos los pasajeros, con materiales premium y un diseño exterior que combina aerodinámica y carácter.`,
        image: `${PLACEHOLDER_HIGHLIGHT}Diseno`,
      },
    ],
    model_features: [
      { id: 1, name: "Seguridad", description: "7 airbags y sistema de frenado ABS con EBD de serie.", photo: `${PLACEHOLDER_FEATURE}Seguridad`, image: `${PLACEHOLDER_FEATURE}Seguridad` },
      { id: 2, name: "Eficiencia", description: "Motor optimizado para un menor consumo de combustible.", photo: `${PLACEHOLDER_FEATURE}Eficiencia`, image: `${PLACEHOLDER_FEATURE}Eficiencia` },
      { id: 3, name: "Conectividad", description: "Pantalla multimedia compatible con Apple CarPlay y Android Auto.", photo: `${PLACEHOLDER_FEATURE}Conectividad`, image: `${PLACEHOLDER_FEATURE}Conectividad` },
      { id: 4, name: "Confort", description: "Climatizador automático y tapizado premium.", photo: `${PLACEHOLDER_FEATURE}Confort`, image: `${PLACEHOLDER_FEATURE}Confort` },
    ],
  };
}

export const mockCars = baseCars.map((c) => ({
  ...c,
  thumbnail: `${PLACEHOLDER_THUMB}${encodeURIComponent(c.name)}`,
  photo: `${PLACEHOLDER_PHOTO}${encodeURIComponent(c.name)}`,
}));

export const mockCarDetails = baseCars.reduce((acc, c) => {
  acc[c.id] = buildDetail(c);
  return acc;
}, {});
